import { useState, useEffect } from 'react';

/**
 * useScrollspy - détecte la section actuellement visible dans le viewport
 * et retourne son id.
 * @param {string[]} sectionIds - liste des id HTML des sections à observer
 */
const useScrollspy = (sectionIds) => {
  const [activeSection, setActiveSection] = useState(sectionIds[0]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        // La section est "active" quand elle occupe le centre de l'écran
        rootMargin: '-20% 0px -55% 0px',
      }
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return activeSection;
};

export default useScrollspy;
